<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-alert outlined type="info" prominent border="left" class="my-10">
          Téléchargez le
          <a href @click.prevent="downloadReport">rapport</a> complet de
          distribution des badges d'accès.
        </v-alert>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row class="text-center">
      <v-col cols="12">
        <div class="title">Semaine</div>
        <v-container ma-0 pa-0>
          <v-row>
            <v-item-group v-model="week" class="full-width">
              <v-container>
                <v-row>
                  <v-col
                    v-for="week in weeks"
                    :key="`week-${week.number}`"
                    cols="12"
                    sm="4"
                  >
                    <v-item
                      v-slot:default="{ active, toggle }"
                      :value="week.number"
                    >
                      <v-card
                        :color="active ? 'green lighten-3' : ''"
                        class="d-flex align-center"
                        height="100"
                        @click="toggle"
                        outlined
                      >
                        <v-card-text>
                          <div class="title">{{ week.number }}</div>
                          <div>
                            {{ week.start | formatWeekday }}-{{
                              week.end | formatWeekday
                            }}
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-item>
                  </v-col>
                </v-row>
              </v-container>
            </v-item-group>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-divider class="mb-10"></v-divider>
    <v-row v-if="week">
      <v-col cols="12">
        <div class="display-1">
          Semaine {{ week }}
          <span class="title"
            >Du
            {{
              this.weeks.find((w) => w.number === week).start
                | formatWeekdayFull
            }}
            au
            {{
              this.weeks.find((w) => w.number === week).end | formatWeekdayFull
            }}</span
          >
        </div>
      </v-col>
    </v-row>
    <v-row class="mt-10">
      <v-col cols="12" sm="6">
        <div class="title">Cheseaux</div>
        <v-expansion-panels>
          <v-expansion-panel
            v-for="weekday in weekdays.filter((w) => w.location === 'cheseaux')"
            :key="weekday.date"
          >
            <v-expansion-panel-header>{{
              weekday.date | formatWeekdayWithDay
            }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              <div v-for="(slot, index) in weekday.slots" :key="slot.date">
                <div class="mt-10">
                  <v-container pa-0>
                    <v-row>
                      <v-col sm="6" v-if="index === 0">Demandes ajoutées</v-col>
                      <v-col sm="6" v-else>{{ slot.date | formatTime }}</v-col>
                      <v-col sm="6" class="text-right" v-if="index === 0">
                        <v-btn
                          icon
                          text
                          small
                          @click="openDialog(slot.date, 'cheseaux')"
                        >
                          <v-icon dark small>mdi-plus-circle-outline</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </div>
                <v-divider></v-divider>
                <div class="mt-5">
                  <v-checkbox
                    v-for="order in slot.orders"
                    :key="order._id"
                    v-model="
                      slot.orders.find((o) => o._id === order._id).delivered
                    "
                    :label="`${order.attendee.firstname} ${order.attendee.lastname}`"
                    @change="updatePayload(order)"
                    dense
                    class="ma-0 pa-0"
                  ></v-checkbox>
                </div>
              </div>
              <div class="text-right">
                <v-btn text @click="exportData(weekday.date, 'cheseaux')"
                  >exporter</v-btn
                >
                <v-btn text @click="updateOrders">enregistrer</v-btn>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
      <v-col cols="12" sm="6">
        <div class="title">St-Roch</div>
        <v-expansion-panels>
          <v-expansion-panel
            v-for="weekday in weekdays.filter((w) => w.location === 'st-roch')"
            :key="weekday.date"
          >
            <v-expansion-panel-header>{{
              weekday.date | formatWeekdayWithDay
            }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              <div v-for="(slot, index) in weekday.slots" :key="slot.date">
                <div class="mt-10">
                  <v-container pa-0>
                    <v-row>
                      <v-col sm="6" v-if="index === 0">Demandes ajoutées</v-col>
                      <v-col sm="6" v-else>{{ slot.date | formatTime }}</v-col>
                      <v-col sm="6" class="text-right" v-if="index === 0">
                        <v-btn
                          icon
                          text
                          small
                          @click="openDialog(slot.date, 'st-roch')"
                        >
                          <v-icon dark small>mdi-plus-circle-outline</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </div>
                <v-divider></v-divider>
                <div class="mt-5">
                  <v-checkbox
                    v-for="order in slot.orders"
                    :key="order._id"
                    v-model="
                      slot.orders.find((o) => o._id === order._id).delivered
                    "
                    :label="`${order.attendee.firstname} ${
                      order.attendee.lastname
                    }`"
                    @change="updatePayload(order)"
                    dense
                    class="ma-0 pa-0"
                  ></v-checkbox>
                </div>
              </div>
              <div class="text-right">
                <v-btn text @click="exportData(weekday.date, 'st-roch')"
                  >exporter</v-btn
                >
                <v-btn text @click="updateOrders">enregistrer</v-btn>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <v-snackbar
      v-model="snackbar.visible"
      :bottom="true"
      :left="true"
      :color="snackbar.color"
    >
      {{ snackbar.text }}
      <v-btn dark text @click="snackbar.visible = false">Fermer</v-btn>
    </v-snackbar>
    <v-dialog v-model="dialog" width="500px">
      <v-card v-if="dialog">
        <v-card-title>Ajouter une demande</v-card-title>
        <v-card-text>
          <div class="my-5">
            Date: {{ this.order.slot | formatWeekdayFull }}, Lieu:
            {{ this.order.location === "cheseaux" ? "Cheseaux" : "St-Roch" }}
          </div>
          <v-autocomplete
            outlined
            :items="employees"
            v-model="order.user"
            :search-input.sync="searchEmployees"
            label="Rechercher une personne..."
            dense
          ></v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeDialog" :disabled="submitting"
            >Annuler</v-btn
          >
          <v-btn
            text
            @click="createOrder"
            :loading="submitting"
            :disabled="!order.user"
            >Sauvegarder</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
import { format, isSameDay, parseISO, isBefore } from "date-fns";
import { fr } from "date-fns/locale";
import fileDownload from "js-file-download";
import { debounce } from "lodash";

export default {
  name: "AdminPart",
  async mounted() {
    const {
      data: { weeks, current },
    } = await axios({
      method: "get",
      url: `${process.env.VUE_APP_API_URI}/admin/weeks`,
    });
    this.weeks = weeks;
    this.week = current;
  },
  data: () => ({
    searchEmployees: null,
    loading: false,
    submitting: false,
    dialog: false,
    weeks: [],
    year: 2021,
    weekdays: [],
    week: undefined,
    selected: [],
    employees: [],
    order: {
      slot: "",
      location: "",
      user: undefined,
    },
    snackbar: {
      visible: false,
      color: "",
      text: "",
    },
  }),
  methods: {
    async exportData(date, location) {
      const { data } = await axios({
        method: "get",
        url: `${process.env.VUE_APP_API_URI}/admin/orders/export?date=${date}&location=${location}`,
        responseType: "arraybuffer",
      });
      fileDownload(data, "requests.xlsx");
    },
    async downloadReport() {
      const { data } = await axios({
        method: "get",
        url: `${process.env.VUE_APP_API_URI}/admin/orders/full-export`,
        responseType: "arraybuffer",
      });
      fileDownload(data, "report.xlsx");
    },
    async updateOrders() {
      await axios({
        method: "patch",
        url: `${process.env.VUE_APP_API_URI}/admin/orders`,
        data: this.selected,
      });
      this.snackbar = {
        visible: true,
        color: "success",
        text: "Les mises à jour ont été effectuées avec succès.",
      };
    },
    async createOrder() {
      this.submitting = true;
      const {
        data: { order },
      } = await axios({
        method: "post",
        url: `${process.env.VUE_APP_API_URI}/admin/orders`,
        data: this.order,
      });

      this.weekdays
        .find((wd) => isSameDay(parseISO(wd.date), parseISO(this.order.slot)))
        .slots[0].orders.push(order);
      this.closeDialog();
      this.submitting = false;
      this.snackbar = {
        visible: true,
        color: "success",
        text: "Les mises à jour ont été effectuées avec succès.",
      };
    },
    updatePayload(value) {
      if (this.selected.find((s) => s._id === value._id)) {
        this.selected.find((s) => s._id === value._id).delivered =
          this.selected.find((s) => s._id === value._id).delivered === false;
      } else {
        this.selected.push({ _id: value._id, delivered: value.delivered });
      }
    },
    openDialog(slot, location) {
      this.order.slot = slot;
      this.order.location = location;
      this.dialog = !this.dialog;
    },
    closeDialog() {
      this.searchEmployees = null;
      this.order.user = undefined;
      this.employees = [];
      this.order.slot = "";
      this.order.location = "";
      this.dialog = !this.dialog;
    },
    async queryPicker(v) {
      this.loading = true;
      const { data: contacts } = await axios({
        method: "get",
        url: `${process.env.VUE_APP_API_URI}/admin/employees?search=${v}`,
      });
      this.employees = contacts;
      this.loading = false;
    },
  },
  watch: {
    async year() {
      const { data } = await axios({
        method: "get",
        url: `${process.env.VUE_APP_API_URI}/admin/weeks`,
      });
      this.weeks = data.weeks;
      this.week = data.year === this.year ? data.current : undefined;
    },
    async week() {
      if (this.week) {
        const { data: weekdays } = await axios({
          method: "get",
          url: `${process.env.VUE_APP_API_URI}/admin/orders?year=${this.year}&weekNumber=${this.week}`,
        });
        this.weekdays = weekdays;
      }
    },
    "order.slot": function () {
      this.employees = this.employees.map((e) => {
        e.disabled = isBefore(parseISO(this.order.slot), parseISO(e.next));
        return e;
      });
    },
    searchEmployees: debounce(function (val) {
      val && this.queryPicker(val);
    }, 300),
  },
  filters: {
    formatWeekday(value) {
      return format(parseISO(value), "dd.MM");
    },
    formatWeekdayWithDay(value) {
      return format(parseISO(value), "EEEE dd.MM", { locale: fr });
    },
    formatWeekdayFull(value) {
      return format(parseISO(value), "dd.MM.yyyy");
    },
    formatTime(value) {
      return format(parseISO(value), "HH:mm");
    },
  },
};
</script>

<style>
.full-width {
  width: 100%;
}
</style>